import { useState, useEffect } from "react";

const DISMISS_KEY = "hevea_pwa_prompt_dismissed";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [showIosHelp, setShowIosHelp] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);

    let iosTimer;
    if (isIos()) {
      iosTimer = setTimeout(() => setVisible(true), 4000);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      if (iosTimer) clearTimeout(iosTimer);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      setVisible(false);
      localStorage.setItem(DISMISS_KEY, "1");
    } else {
      setShowIosHelp(true);
    }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 sm:max-w-sm z-[60] bg-white border border-green-200 shadow-xl rounded-2xl p-4"
      data-testid="pwa-install-banner"
    >
      {showIosHelp ? (
        <div className="text-sm text-gray-700 space-y-2">
          <p className="font-semibold text-green-800">📱 Instalar no iPhone/iPad:</p>
          <p>1. Toque no botão <strong>Compartilhar</strong> (quadrado com seta ↑) na barra do Safari</p>
          <p>2. Escolha <strong>"Adicionar à Tela de Início"</strong></p>
          <button
            onClick={dismiss}
            className="w-full mt-1 py-2 rounded-lg bg-green-600 text-white font-semibold text-sm"
            data-testid="pwa-ios-ok-btn"
          >
            Entendi
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <img src="/icon-192x192.png" alt="HeveaTalent" className="w-12 h-12 rounded-xl flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-green-900">Instale o HeveaTalent</p>
            <p className="text-xs text-gray-600">Acesse com um toque, direto da tela inicial</p>
          </div>
          <div className="flex flex-col gap-1.5 flex-shrink-0">
            <button
              onClick={install}
              className="px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-700 text-white text-xs font-semibold"
              data-testid="pwa-install-btn"
            >
              Instalar
            </button>
            <button
              onClick={dismiss}
              className="px-3 py-1 rounded-lg text-gray-500 hover:text-gray-700 text-xs"
              data-testid="pwa-dismiss-btn"
            >
              Agora não
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InstallPrompt;
